module.exports = __webpack_public_path__ + "img/21481632277379_.pic.1b52bd9c.png";